module.exports = "<fb-fact fact=\"$ctrl.fact\" on-update=\"$ctrl.editFact(newFact)\" on-cancel=\"$dismiss()\"></fb-fact>\n"


//////////////////
// WEBPACK FOOTER
// ./project/modals/fact/fact.html
// module id = 850
// module chunks = 3